module.exports = __webpack_public_path__ + "static/img/center-icon.bc21e36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/center-icon.png
// module id = P5T9
// module chunks = 0